import { render, staticRenderFns } from "./Bottom-navigation.vue?vue&type=template&id=171889c8&scoped=true&"
import script from "./Bottom-navigation.vue?vue&type=script&lang=js&"
export * from "./Bottom-navigation.vue?vue&type=script&lang=js&"
import style0 from "./Bottom-navigation.vue?vue&type=style&index=0&id=171889c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171889c8",
  null
  
)

export default component.exports